module.exports = __webpack_public_path__ + "img/small-close.d3438926.svg";